module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/ui/user-login/user-login.component.scss
// module id = ./src/app/ui/user-login/user-login.component.scss
// module chunks = main